import { Container, Row, Col } from "react-bootstrap";
import MarketingImage from "../../app/assets/images/MarketingImage.svg";
import useWindowSize from "../../hooks/useWindowSize";
import "../../custom.scss";
import "./auth-layout.scss";

type LayoutProps = {
  children: React.ReactNode;
  xl?: number;
  md?: number;
  lg?: number;
  xxl?: number;
  login?: boolean;
  register?: boolean;
};

export const Layout = (props: LayoutProps) => {
  const { width } = useWindowSize();
  return (
    <>
      <Container fluid>
        <Row className="vh-100 m-0">
          <Col
            md={5}
            xl={props.register ? 4 : 5}
            className="d-none d-lg-flex h-100 align-items-xl-center flex-shrink-0"
          >
            <div className="py-4 px-2 position-sticky top-0">
              <img
                src={MarketingImage}
                alt="CPAAS"
                className="img-fluid"
                style={{ maxHeight: "calc(100dvh - 50px)" }}
              />
            </div>
          </Col>
          <Col
            md={7}
            xl={props.register ? 8 : 7}
            className="d-flex flex-column align-items-center justify-content-xl-center mx-auto mt-4"
            xs="12"
            lg="7"
          >
            <Row className="align-items-center justify-content-center w-100">
              <Col
                xs={12}
                lg={props.lg ?? 9}
                xl={props.xl ?? 9}
                xxl={props.xxl ?? 7}
                className={`${props.register && width >= 992 && width < 1450 ? "scrollable-column" : ""}`}
              >
                {props.children}
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </>
  );
};
